module.exports = __webpack_public_path__ + "static/media/engineered-systems@2x.efab8046.jpg";